// Contenuti e definizioni della sezione Usato (pagine di atterraggio, FAQ, testo SEO).
// Le categorie rispecchiano usato.CATEGORIE lato backend (sitemap).

export const slugify = (s) =>
  s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const CATEGORIE_USATO = {
  "veicoli-commerciali": {
    nome: "Veicoli commerciali usati a noleggio lungo termine",
    h1: "Noleggio lungo termine usato: furgoni e veicoli commerciali",
    intro: "Veicoli commerciali NLT Re-Use con chilometraggio contenuto, pronti per lavorare: selezionati dallo stock aggiornato ogni ora.",
    filtro: (a) => a.tipo_veicolo === "commerciale",
  },
  "cambio-automatico": {
    nome: "Auto usate automatiche a noleggio lungo termine",
    h1: "Noleggio lungo termine usato con cambio automatico",
    intro: "Tutte le auto a stock con cambio automatico: Noleggio Lungo Termine SecondLife, con massimo 70/80.000 km e le stesse garanzie di un noleggio a lungo termine.",
    filtro: (a) => (a.cambio || "").startsWith("Automatico"),
  },
  elettriche: {
    nome: "Auto elettriche usate a noleggio lungo termine",
    h1: "Noleggio lungo termine usato: auto elettriche",
    intro: "Elettriche NLT Re-Use a fine primo ciclo: chilometraggio certificato e risparmio fino al 40% rispetto al noleggio tradizionale.",
    filtro: (a) => a.alimentazione === "Elettrico",
  },
  ibride: {
    nome: "Auto ibride usate a noleggio lungo termine",
    h1: "Noleggio lungo termine usato: ibride e plug-in",
    intro: "Hybrid e Plug-in Hybrid SecondLife, selezionate una a una e rimesse nel circuito del noleggio con tutte le garanzie.",
    filtro: (a) => a.alimentazione === "Hybrid" || a.alimentazione === "Plug-in Hybrid",
  },
  diesel: {
    nome: "Auto diesel usate a noleggio lungo termine",
    h1: "Noleggio lungo termine usato: auto diesel",
    intro: "Diesel NLT Re-Use con massimo 70/80.000 km, ideali per chi percorre tanti chilometri.",
    filtro: (a) => a.alimentazione === "Diesel",
  },
  benzina: {
    nome: "Auto benzina usate a noleggio lungo termine",
    h1: "Noleggio lungo termine usato: auto a benzina",
    intro: "Benzina NLT Re-Use recenti, selezionate dallo stock aggiornato ogni ora.",
    filtro: (a) => a.alimentazione === "Benzina",
  },
};

// Solo fatti indicati dal titolare (km massimi, garanzie come il NLT, risparmio fino al 40%, aggiornamento orario, prezzo su richiesta).
export const FAQ_USATO = [
  {
    q: "Cos'è il noleggio lungo termine usato SecondLife (NLT Re-Use) di XMOVE?",
    a: "È il noleggio lungo termine di auto usate: vetture che hanno appena concluso un primo ciclo di noleggio, con massimo 70/80.000 km. Selezioniamo le migliori e le rimettiamo nel circuito del noleggio con la formula SecondLife.",
  },
  {
    q: "Che garanzie ho su un'auto NLT Re-Use?",
    a: "Le stesse di un noleggio a lungo termine tradizionale: assistenza e servizi identici, ma su un'auto già immatricolata e quindi con un risparmio fino al 40% sul canone.",
  },
  {
    q: "Perché non vedo il prezzo su tutte le auto?",
    a: "Lo stock si aggiorna ogni ora e le quotazioni vengono inserite man mano dai nostri consulenti. Se vedi \"prezzo su richiesta\", compila il modulo o scrivici su WhatsApp: ti rispondiamo con disponibilità, canone e condizioni.",
  },
  {
    q: "Ogni quanto si aggiorna lo stock usato?",
    a: "Ogni ora durante l'orario lavorativo. Le auto che vedi sono disponibili adesso; quelle già assegnate spariscono automaticamente dal sito.",
  },
  {
    q: "Posso vedere foto e video dell'auto?",
    a: "Sì: ogni scheda ha la foto dell'auto e il link al visore con tutte le foto e il video a 360° realizzati al rientro dal noleggio.",
  },
];

// FAQ della pagina pillar /noleggio-lungo-termine-usato/ (stessi fatti; formulazioni mirate alla ricerca "noleggio lungo termine usato").
export const FAQ_NLT_USATO = [
  {
    q: "Cos'è il noleggio lungo termine usato?",
    a: "È il noleggio a lungo termine applicato ad auto che hanno già concluso un primo ciclo di noleggio: canone mensile tutto incluso (assicurazioni, manutenzione, assistenza) su una vettura con massimo 70/80.000 km, selezionata e rimessa nel circuito. In XMOVE lo chiamiamo SecondLife o NLT Re-Use.",
  },
  {
    q: "Quanto si risparmia con il noleggio lungo termine di un'auto usata?",
    a: "Fino al 40% rispetto al canone della stessa auto nuova, a parità di servizi inclusi: l'auto ha già assorbito la parte più pesante della svalutazione.",
  },
  {
    q: "Le garanzie sono le stesse del noleggio a lungo termine di un'auto nuova?",
    a: "Sì. Assicurazioni, manutenzione e assistenza sono identiche a un noleggio a lungo termine tradizionale: cambia l'auto, non il servizio.",
  },
  {
    q: "Quanti chilometri hanno le auto del noleggio lungo termine usato?",
    a: "Al massimo 70/80.000 km. Ogni scheda riporta i chilometri reali con la data di rilevazione, l'anno di immatricolazione e le dotazioni.",
  },
  {
    q: "Posso scegliere qualsiasi auto?",
    a: "Si sceglie tra le auto selezionate a stock, filtrabili per marca, alimentazione, cambio, potenza e tipo (auto, veicoli commerciali, scooter). Lo stock si aggiorna ogni ora e le auto assegnate spariscono subito dal sito.",
  },
  {
    q: "Come chiedo una quotazione?",
    a: "Dalla scheda dell'auto clicca \"contattaci per avere info\" o scrivici su WhatsApp: un consulente XMOVE ti risponde con disponibilità, canone mensile e condizioni. Quando disponibile, la scheda mostra già prezzo ed esempio di quotazione.",
  },
  {
    q: "Il noleggio lungo termine usato è adatto a partita IVA e aziende?",
    a: "Sì: valgono le stesse regole del noleggio a lungo termine tradizionale, con canone tutto incluso. Per i dettagli fiscali consulta la nostra guida alla deducibilità o chiedi al consulente.",
  },
];
